import WySmartTagHomePage from '../components/smartTag/wy-smartTag-dashboard.vue'
export default [
  {
    path: '/smartTag',
    name: 'smartTagDashboard',
    component: WySmartTagHomePage,
    meta: { 
      bindModel: 'chat-autoQA',
      filterAction: 'fetchChatFilters',
      filterNames: ['date', 'directions', 'agentGroups', 'agentTeams', 'agents', 'speakers'],
      headerMenuItems: [
        // {name:'form-filter-dropdown-widget'},
        {name:'date-widget', properties:{disableToday: true}},
        {name:'direction-dropdown-widget'},
        {name:'speakers-dropdown-widget'},
        {name:'interactions-filtering-widget'},
      ]
    }
  },
]